import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import StudentMenu from "./StudentMenu";
import { toast, ToastContainer } from "react-toastify";
import { NavLink } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import ShowStudent from "../Shared/ShowStudent";
import { scrollToTop } from "../Shared/ScrollOnTop";
import YearsDropDown from "../Shared/YearsDropDown";
import MonthsDropDown from "../Shared/MonthsDropDown";

function StudentLedger2(props) {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [UserName, setUserName] = useState(localStorage.getItem("UserName"));
    const [SessionID, setSessionID] = useState(
        localStorage.getItem("DefaultSession")
    );
    const grp_id = localStorage.getItem("User_Group_ID");
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );

    const [loading, setLoading] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const [RepostLoading, setRepostLoading] = useState(false)

    const [listOfLedger, setLedger] = useState([]);
    const [fullLedger, setFullLedger] = useState([]);
    const [filteredLedger, setFilteredLedger] = useState([]);
    const [filterMonth, setFilterMonth] = useState(String(moment().month() + 1));
    const [filterYear, setFilterYear] = useState(moment().format("YYYY"));
    const [filterChallanNo, setFilterChallanNo] = useState("");

    const [isUpdated, setIsUpdated] = useState(false);
    const [showLedgers, setShowLedgers] = useState(true);

    // pagination
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(1000);
    const [totalRecords, setTotalRecords] = useState(0);
    const [test, setTest] = useState(false);

    let params = useParams();

    const [StudentID, setStudentID] = useState(params.id);
    const [StartDate, setStartDate] = useState("2023-01-01");
    const [EndDate, setEndDate] = useState("2030-06-01");

    let totalReceivedAmount = 0;
    let totalPendingFee = 0;
    let totalReceiveableAmount = 0;
    let navigate = useNavigate();

    const fetchData = () => {
        setIsUpdated(true);
    };

    useEffect(() => {
        document.title = "View Student Ledger";
        setIsUpdated(false);
        setLoading(true);
        setLoadings(true);
        fetchData();
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            Student_ID: StudentID
        };

        var api_config = {
            method: "post",
            url: config.base_url + "ADLedger/GetADLedgerOfStudentAll",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(api_config)
            .then(function (response) {
                // console.log(response.data);
                if (response.data.status_code === 1) {
                    const records = response.data.ListofRecords || [];
                    const defaultMonth = String(moment().month() + 1);
                    const defaultYear = moment().format("YYYY");
                    const filtered = records.filter((item) => {
                        if (!item.PostingDate || !moment(item.PostingDate).isValid()) {
                            return false;
                        }
                        const month = moment(item.PostingDate).month() + 1;
                        const year = moment(item.PostingDate).format("YYYY");
                        return String(month) === defaultMonth && year === defaultYear;
                    });

                    setFilterMonth(defaultMonth);
                    setFilterYear(defaultYear);
                    setFullLedger(records);
                    setFilteredLedger(filtered);
                    setLedger(filtered.slice((pageNo - 1) * pageSize, pageNo * pageSize));
                    setLoading(false);
                    setLoadings(false);
                    setTotalRecords(filtered.length);
                } else {
                    setLedger([]);
                    setFullLedger([]);
                    setFilteredLedger([]);
                    setTotalRecords(0);
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                    setLoadings(false);
                }
            })

            .catch(function (error) {
                ////console.log(error);
            });
        setTest(false);
    }, [isUpdated]);

    useEffect(() => {
        const paged = filteredLedger.slice((pageNo - 1) * pageSize, pageNo * pageSize);
        setLedger(paged);
        setTotalRecords(filteredLedger.length);
    }, [pageNo, pageSize, filteredLedger]);


    const handlePageChange = (page) => {
        setPageNo(page);
    };

    const applyFilters = () => {
        let filtered = [...fullLedger];

        if (filterChallanNo && filterChallanNo.trim().length > 0) {
            const challan = filterChallanNo.trim();
            filtered = filtered.filter((item) => item.Challan_No === challan);
        } else if (filterMonth && filterYear) {
            const selectedMonth = parseInt(filterMonth, 10);
            filtered = filtered.filter((item) => {
                if (!item.PostingDate || !moment(item.PostingDate).isValid()) {
                    return false;
                }
                const month = moment(item.PostingDate).month() + 1;
                const year = moment(item.PostingDate).format("YYYY");
                return month === selectedMonth && year === filterYear;
            });
        }

        setPageNo(1);
        setFilteredLedger(filtered);
        setLedger(filtered.slice(0, pageSize));
        setTotalRecords(filtered.length);
    };

    const resetFilters = () => {
        setFilterMonth("");
        setFilterYear("");
        setFilterChallanNo("");
        setPageNo(1);
        setFilteredLedger(fullLedger);
        const paged = fullLedger.slice(0, pageSize);
        setLedger(paged);
        setTotalRecords(fullLedger.length);
    };

    ////console.log(grp_id);
    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            return listOfLedger.map((item, index) => {
                // if (item.Fee_Code != "018") {
                //   totalReceivedAmount += item.Debit;
                // }
                totalReceivedAmount += item.ReceivedAmount;
                totalPendingFee += item.PendingFee;
                totalReceiveableAmount += item.ReceiveableFee;

                return (
                    <>
                        <tr key={index}>
                            {/* <td>{item.ID}</td> */}
                            <td>{moment(item.PostingDate).format("MMM YYYY")}</td>
                            <td>{item.Challan_No}</td>
                            <td>{item.FeeCode}</td>
                            <td>{item.Fee_Posted}</td>
                            <td>{item.ConcessionAmount}</td>
                            <td>{item.ReceiveableFee}</td>
                            <td>{item.Arrears}</td>
                            <td>{item.Description}</td>
                            <td>{item.ReceivedAmount}</td>
                            <td>{item.ReceivedDate ? moment(item.ReceivedDate).format("DD/MM/YYYY") : ""}</td>
                            <td>{item.PendingFee}</td>
                        </tr>
                    </>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="11">
                        <h4
                            className="mt-3"
                            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                        >
                            No Data Found
                        </h4>
                    </td>
                </tr>
            );
        }
    };

    // const handleCurrentMonthData = () => {
    //   const currentDate = moment();
    //   const year = currentDate.format("YYYY");
    //   const month = currentDate.format("MM");
    //   setCurrentYear(year);
    //   setCurrentMonth(month);

    //   setIsUpdated(false);
    //   setLoading(true);

    //   const data = {
    //     AccessKey: AccessKey,
    //     UserID: UserID,
    //     MemberType: MemberType,
    //     pageNo: pageNo,
    //     pageSize: pageSize,
    //     Student_ID: StudentID,
    //     StartDate: StartDate,
    //     EndDate: EndDate,
    //   };
    //   ////console.log(currentMonth, currentYear);
    //   var api_config = {
    //     method: "post",
    //     url: config.base_url + "Student/GetStudentLedger",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: data,
    //   };

    //   axios(api_config)
    //     .then(function (response) {
    //       ////console.log(response.data);
    //       if (response.data.status_code === 1) {
    //         const filtered = response.data.ListofRecords.filter((val) => {
    //           const dateObj = new Date(val.Transaction_Date);
    //           const month = dateObj.getMonth() + 1;
    //           const formattedMonth = month.toString().padStart(2, "0");

    //           const year = dateObj.getFullYear();
    //           ////console.log(currentYear);
    //           return formattedMonth == currentMonth && year == currentYear;
    //         });
    //         setLedger(filtered);
    //         setLoading(false);
    //         setTotalRecords(response.data.totalRecords);
    //       } else {
    //         setLedger(null);
    //         setTotalRecords(0);
    //         toast.error(response.data.status_message, {
    //           position: toast.POSITION.TOP_RIGHT,
    //         });
    //         setLoading(false);
    //       }
    //     })
    //     .catch(function (error) {
    //       ////console.log(error);
    //     });
    // };


    return (
        <>
            <StudentMenu />

            <ToastContainer />

            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <NavLink to="/Dashboard">Dashboard</NavLink>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <NavLink to="/student/studentdashboard">Students</NavLink>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Student Ledger
                                        </li>
                                    </ol>
                                </nav>
                                <div className="page-title">Student Ledger</div>
                            </div>
                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    {/* <NavLink
                    to="/students/AdvanceSearch"
                    className="button button-white"
                  >
                    Back
                  </NavLink> */}
                                    <button
                                        onClick={() => {
                                            setShowLedgers((prevIsActive) => !prevIsActive);
                                        }}
                                        className="button button-white button-icon"
                                    >
                                        {showLedgers ? "Hide Detail" : "Show Detail"}
                                        <i className="ri-filter-3-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <StudentCard StudentID={StudentID} /> */}
                <div
                    className={`collapse ${showLedgers ? "show" : ""} `}
                    id="collapseFilteres"
                >
                    <ShowStudent StudentID={StudentID} />
                </div>
                <div className="page-content mt-3">
                    <div className="container">
                        <div className="card">
                            <div className="card-body">
                                <div className="row mb-3">
                                    <div className="col-md-3">
                                        <label className="form-label">Filter Month</label>
                                        <select
                                            className="form-select"
                                            value={filterMonth}
                                            onChange={(e) => setFilterMonth(e.target.value)}
                                        >
                                            <option value="">All</option>
                                            <MonthsDropDown />
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">Filter Year</label>
                                        <select
                                            className="form-select"
                                            value={filterYear}
                                            onChange={(e) => setFilterYear(e.target.value)}
                                        >
                                            <option value="">All</option>
                                            <YearsDropDown />
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label className="form-label">Challan No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={filterChallanNo}
                                            onChange={(e) => setFilterChallanNo(e.target.value)}
                                            placeholder="Enter challan number"
                                        />
                                    </div>
                                    <div className="col-md-3 d-flex align-items-end gap-2">
                                        <button
                                            type="button"
                                            className="button button-primary"
                                            onClick={applyFilters}
                                        >
                                            Apply
                                        </button>
                                        <button
                                            type="button"
                                            className="button button-light"
                                            onClick={resetFilters}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>

                                <table className="table table-theme">
                                    <thead>
                                        <tr>
                                            <th colSpan="11" className="text-end">
                                                {totalRecords} Records Found!
                                            </th>
                                        </tr>
                                        <tr>
                                            {/* <th>Transaction ID</th> */}
                                            <th>Fee Month</th>
                                            <th>Challan No</th>
                                            <th>Fee Code</th>
                                            <th>Fee Posted</th>
                                            <th>Concession Amount</th>
                                            <th>Receiveable Fee</th>
                                            <th>Arrears</th>
                                            <th>Description</th>
                                            <th>Received Amount</th>
                                            <th>Received Date</th>
                                            <th>Pending Fee</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td className="text-center" colSpan="11">
                                                    <Spinner animation="border" role="status"></Spinner>
                                                </td>
                                            </tr>
                                        ) : (
                                            <>{renderLedger()}</>
                                        )}
                                        <tr>
                                            <td colSpan="5"></td>
                                            <td className="text-end">
                                                <b> Total Receiveable Fee: </b>
                                            </td>
                                            <td>
                                                <b>{totalReceiveableAmount} </b>
                                            </td>
                                            <td className="text-end">
                                                <b> Total Received Amount: </b>
                                            </td>
                                            <td>
                                                <b>{totalReceivedAmount} </b>
                                            </td>
                                            <td className="text-end">
                                                <b> Total Pending Fee: </b>
                                            </td>
                                            <td>
                                                <b>{totalPendingFee} </b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={6}></td>
                                            <td colSpan={2} className="text-end">
                                                <b> Total Payable : </b>
                                            </td>
                                            <td>
                                                <b>{totalPendingFee}</b>
                                            </td>
                                            <td colSpan="2"></td>
                                        </tr>
                                    </tbody>
                                </table>
                                {totalRecords > 1000 && (
                                    <div className="pagination-wrap">
                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>
                                                        Page Size
                                                    </label>
                                                    <div className="form-group">
                                                        <select
                                                            className="form-select"
                                                            style={{ width: "100px" }}
                                                            onChange={(e) => {
                                                                setPageNo(1);
                                                                setPageSize(parseInt(e.target.value));
                                                            }}
                                                        >
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option value="1000" selected>
                                                                1000
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StudentLedger2;